import { css } from 'styled-components';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';

const globalStyles = /*#__PURE__*/css(["white-space:nowrap;font:", ";box-sizing:border-box;border-radius:", ";border-width:", ";border-style:solid;border-color:transparent;cursor:pointer;text-align:center;vertical-align:middle;justify-content:center;user-select:auto;@media (prefers-reduced-motion:no-preference){transition:color 100ms ease,background-color 100ms ease,border-color 100ms ease;}display:inline-flex;flex-direction:row;flex-wrap:nowrap;align-items:center;gap:", ";", ""], ({
  theme
}) => theme.font.text.base.default, ({
  theme
}) => theme.border.radius.medium, ({
  theme
}) => theme.border.width.default, ({
  theme,
  $small
}) => $small ? theme.button.padding.gap.small : theme.button.padding.gap.base.default, isMobile(css(["gap:", ";"], ({
  theme,
  $small
}) => $small ? theme.button.padding.gap.small : theme.button.padding.gap.base.mobile)));
const colorMixin = themeValueSelector => css(["&&,&&:visited,&&:active,&&:link,&&:hover{color:", ";}"], themeValueSelector);

/*
 * Replace `colorMixin()` with this version if we want to only increase the Link
 * color rule specificity when `theme.link.overrideAuiLinkStyle === true`

const colorMixin = themeValueSelector => ({ theme }) =>{
  if (theme?.globals?.link?.overrideAuiLinkStyle === true) {
    return css`
    &&, &&:visited, &&:active, &&:link, &&:hover{
      color: ${themeValueSelector};
    }`;
  }
  return css`color: ${themeValueSelector};`;
};
*/

const normalStyles = /*#__PURE__*/css(["padding-block-start:", ";padding-block-end:", ";padding-inline-start:", ";padding-inline-end:", ";min-height:", ";border-radius:", ";", ""], ({
  theme
}) => theme.controls.paddingBlock.base.default, ({
  theme
}) => theme.controls.paddingBlock.base.default, ({
  theme
}) => theme.button.padding.inline.base.default, ({
  theme
}) => theme.button.padding.inline.base.default, ({
  theme
}) => theme.controls.height.base.default, ({
  theme
}) => theme.border.radius.medium, isMobile(css(["padding-block-start:", ";padding-block-end:", ";padding-inline-start:", ";padding-inline-end:", ";min-height:", ";font:", ";"], ({
  theme
}) => theme.controls.paddingBlock.base.mobile, ({
  theme
}) => theme.controls.paddingBlock.base.mobile, ({
  theme
}) => theme.button.padding.inline.base.mobile, ({
  theme
}) => theme.button.padding.inline.base.mobile, ({
  theme
}) => theme.controls.height.base.mobile, ({
  theme
}) => theme.font.text.base.mobile)));
const smallStyles = /*#__PURE__*/css(["padding-block-start:", ";padding-block-end:", ";padding-inline-start:", ";padding-inline-end:", ";min-height:", ";font:", ";border-radius:", ";", ""], ({
  theme
}) => theme.controls.paddingBlock.small.default, ({
  theme
}) => theme.controls.paddingBlock.small.default, ({
  theme
}) => theme.button.padding.inline.small.default, ({
  theme
}) => theme.button.padding.inline.small.default, ({
  theme
}) => theme.controls.height.small.default, ({
  theme
}) => theme.font.text.small.default, ({
  theme
}) => theme.border.radius.small, isMobile(css(["padding-block-start:", ";padding-block-end:", ";padding-inline-start:", ";padding-inline-end:", ";min-height:", ";font:", ";"], ({
  theme
}) => theme.controls.paddingBlock.small.mobile, ({
  theme
}) => theme.controls.paddingBlock.small.mobile, ({
  theme
}) => theme.button.padding.inline.small.mobile, ({
  theme
}) => theme.button.padding.inline.small.mobile, ({
  theme
}) => theme.controls.height.small.mobile, ({
  theme
}) => theme.font.text.small.mobile)));
const transparentStyles = /*#__PURE__*/css(["background-color:", ";", " :hover{background-color:", ";}:active{background-color:", ";}:disabled{cursor:not-allowed;outline:none;opacity:1;", " background-color:", ";pointer-events:all;}"], ({
  theme
}) => theme.button.backgroundColor.transparent.default, colorMixin(({
  theme
}) => theme.text.color.default), ({
  theme
}) => theme.button.backgroundColor.transparent.hover, ({
  theme
}) => theme.button.backgroundColor.transparent.active, colorMixin(({
  theme
}) => theme.text.color.unavailable), ({
  theme
}) => theme.button.backgroundColor.transparent.unavailable);
const loadingStyles = /*#__PURE__*/css(["&&[aria-disabled=\"true\"]{cursor:not-allowed;outline:none;opacity:1;", " background-color:", ";pointer-events:none;}"], colorMixin(({
  theme
}) => theme.text.color.unavailable), ({
  theme
}) => theme.button.backgroundColor.secondary.unavailable);
const transparentloadingStyles = /*#__PURE__*/css(["&&[aria-disabled=\"true\"]{cursor:not-allowed;outline:none;opacity:1;", " background-color:", ";pointer-events:none;}"], colorMixin(({
  theme
}) => theme.text.color.unavailable), ({
  theme
}) => theme.button.backgroundColor.transparent.default);
const defaultStyles = /*#__PURE__*/css(["background-color:", ";", " border-width:", ";border-style:solid;border-color:", ";:hover{background-color:", ";border-color:", ";}:active{background-color:", ";border-color:", ";}:disabled{cursor:not-allowed;outline:none;opacity:1;border-color:", ";", " background-color:", ";pointer-events:all;}"], ({
  theme
}) => theme.button.backgroundColor.secondary.default, colorMixin(({
  theme
}) => theme.text.color.default), ({
  theme
}) => theme.border.width.default, ({
  theme
}) => theme.border.color.medium.default, ({
  theme
}) => theme.button.backgroundColor.secondary.hover, ({
  theme
}) => theme.border.color.medium.hover, ({
  theme
}) => theme.button.backgroundColor.secondary.active, ({
  theme
}) => theme.border.color.medium.active, ({
  theme
}) => theme.border.color.medium.unavailable, colorMixin(({
  theme
}) => theme.text.color.unavailable), ({
  theme
}) => theme.button.backgroundColor.secondary.unavailable);
const primaryStyles = /*#__PURE__*/css(["background-color:", ";", " :hover{background-color:", ";}:active{background-color:", ";}:disabled{cursor:not-allowed;outline:none;opacity:1;", " background-color:", ";pointer-events:all;}"], ({
  theme
}) => theme.button.backgroundColor.primary.default, colorMixin(({
  theme
}) => theme.text.color.inverted), ({
  theme
}) => theme.button.backgroundColor.primary.hover, ({
  theme
}) => theme.button.backgroundColor.primary.active, colorMixin(({
  theme
}) => theme.text.color.unavailable), ({
  theme
}) => theme.button.backgroundColor.primary.unavailable);
const defaultAiStyles = /*#__PURE__*/css(["background-color:", ";", " border-width:", ";border-style:solid;border-color:", ";&&:hover{background-color:", ";}&&:active{background-color:", ";color:", ";}&&:disabled{cursor:not-allowed;outline:none;opacity:1;border-color:transparent;", " background-color:", ";pointer-events:all;}"], ({
  theme
}) => theme.button.backgroundColor.defaultAi.default, colorMixin(({
  theme
}) => theme.text.color.default), ({
  theme
}) => theme.border.width.default, ({
  theme
}) => theme.support.borderColor.ai, ({
  theme
}) => theme.button.backgroundColor.defaultAi.hover, ({
  theme
}) => theme.button.backgroundColor.defaultAi.active, ({
  theme
}) => theme.support.textColor.ai, colorMixin(({
  theme
}) => theme.text.color.unavailable), ({
  theme
}) => theme.button.backgroundColor.defaultAi.unavailable);
const primaryAiStyles = /*#__PURE__*/css(["background-color:", ";", " &&:hover{background-color:", ";}&&:active{background-color:", ";}&&:disabled{cursor:not-allowed;outline:none;opacity:1;", " background-color:", ";pointer-events:all;}"], ({
  theme
}) => theme.button.backgroundColor.primaryAi.default, colorMixin(({
  theme
}) => theme.text.color.inverted), ({
  theme
}) => theme.button.backgroundColor.primaryAi.hover, ({
  theme
}) => theme.button.backgroundColor.primaryAi.active, colorMixin(({
  theme
}) => theme.text.color.unavailable), ({
  theme
}) => theme.button.backgroundColor.primaryAi.unavailable);

export { primaryStyles as a, defaultStyles as b, transparentloadingStyles as c, defaultAiStyles as d, colorMixin as e, globalStyles as g, loadingStyles as l, normalStyles as n, primaryAiStyles as p, smallStyles as s, transparentStyles as t };
//# sourceMappingURL=Button.styles-BP_xqiGy.js.map
